export default "__VITE_ASSET__D1QK1pUY__"